/* External Imports */
import React from 'react';

/* Built In Imports */
import { Box, SimpleGrid } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';

/* Internal Imports */
/* Components */
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';

/**
 * @param {Object} sectionContent
 * @param {String} lang
 * @param {String} region
 * @returns
 */

const ProgramWish = ({ region, lang, sectionContent }) => {
  const programHeading = sectionContent?.find(
    e => e.fieldId === 'program-for-heading'
  );

  return (
    <Box
      bg="#fff"
      py={{ base: '5.625rem', md: '9rem' }}
      px={'1.25rem'}
      borderRadius="lg"
      color={'#525252'}
      maxWidth="1030px"
      mx="auto"
      id="program-for-you"
    >
      {/* Centered Heading */}
      {programHeading && (
        <StructuredTextParser
          str={render(programHeading?.body)}
          fontSize={{ base: '1.625rem', md: '3.125rem' }}
          lineHeight={{ base: '2.11rem', md: '4.25rem' }}
          fontFamily="FedraSansStd-medium"
          textAlign="center"
          maxW={{ base: '100% !important', md: '70% !important' }}
          mb={{ base: '3px', md: '47px' }}
          mx="auto"
          className="wish_heading"
        />
      )}

      {/* Two-Column Layout for Items */}
      <SimpleGrid
        columns={[1, 2]}
        spacing={'2.25rem'}
        mx="auto"
        // mt={{ base: '1.88rem', md: '4.38rem' }}
        px={{ base: '2rem', md: '4rem' }}
      >
        {sectionContent[1]?.cards?.map((item, index) => (
          <Box key={index} align="baseline" gap="1.25rem">
            <StructuredTextParser
              str={render(item?.description)}
              fontSize={{ base: '1.125rem', md: '1.625rem' }}
              lineHeight={{ base: '1.4rem', md: '2rem' }}
              fontFamily="FedraSansStd-book"
              className="remark_program"
            />
          </Box>
        ))}
        {sectionContent[2]?.cards?.map((item, index) => (
          <Box key={index} align="baseline" mt={{ base: '-3rem', sm: '0' }}>
            <StructuredTextParser
              str={render(item?.description)}
              fontSize={{ base: '1.125rem', md: '1.625rem' }}
              lineHeight={{ base: '1.4rem', md: '2rem' }}
              fontFamily="FedraSansStd-book"
              className="remark_program"
            />
          </Box>
        ))}
      </SimpleGrid>
      <style>{`
        .remark_program ul{
          list-style: none;
          list-style-image: url('https://static.sadhguru.org/d/46272/1733388639-right_green-icon.png');
        }
        .remark_program ul li{
          padding: 16px 8px;
        }
        .wish_heading mark{
          background: #fff;
          color:#12166F
          }
        .wish_heading h2{
          color:#F37021
        }
      `}</style>
    </Box>
  );
};

export default ProgramWish;
